
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import { handleApiError } from "utils/apiUtils";
import { getNotifications, loginUser, registerUser, resendOtp, resetPassword, sendForgotPasswordMail, verifyOtp } from "api/authApi";
import { setNotificationsdata } from "states/auth/authSlice";


// Auth Action: Register Api
export const RegisterApi = createAsyncThunk(
    "auth/register",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await registerUser(data); // Call API function

            localStorage.setItem("user", JSON.stringify(response?.data?.user));
            return response;
        } catch (error) {
            return handleApiError(error, rejectWithValue); // Handle errors through a helper function
        }
    }
);

// Auth Action: Login User
export const LoginApi = createAsyncThunk(
    "auth/login",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await loginUser(data);

            localStorage.setItem("user", JSON.stringify(response?.data?.user));
            localStorage.setItem("token", response?.data?.token);
            return response;
        } catch (error) {
            return handleApiError(error, rejectWithValue);
        }
    }
);

// Auth Action: Send Forgot Password Mail
export const ForgotPasswordApi = createAsyncThunk(
    "auth/send-forgot-password-mail",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await sendForgotPasswordMail(data);

            return response;
        } catch (error) {
            return handleApiError(error, rejectWithValue);
        }
    }
);

// Auth Action: Reset Password
export const ResetPasswordApi = createAsyncThunk(
    "auth/reset-password",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await resetPassword(data);

            return response;
        } catch (error) {
            return handleApiError(error, rejectWithValue);
        }
    }
);

// Auth Action: Verify User OTP
export const VerifyOtpApi = createAsyncThunk(
    "auth/verify",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await verifyOtp(data);
            // veryfy done => login done
            localStorage.setItem("user", JSON.stringify(response?.data?.user));
            localStorage.setItem("token", response?.data?.token);

            return response;
        } catch (error) {
            return handleApiError(error, rejectWithValue);
        }
    }
);

// Auth Action: Resend User OTP
export const ResendOtpApi = createAsyncThunk(
    "auth/verify/resend",
    async ({ data }, { rejectWithValue }) => {
        try {
            const response = await resendOtp(data);

            return response;
        } catch (error) {
            return handleApiError(error, rejectWithValue);
        }
    }
);

// Create AsyncThunk for fetching notifications
export const getNotificationsApi = createAsyncThunk(
    "notifications/getNotifications", // Action type
    async ({ token }, { rejectWithValue, dispatch }) => {
        console.log('etNotificationsApi');
        try {
            const response = await getNotifications(token); // Call the API function

            console.log(response)

            // Dispatch action to set notifications data in Redux store
            dispatch(setNotificationsdata(response?.data));

            return response; // Return the response data
        } catch (error) {
            // Show an error toast message if the request fails
            toast.error("Failed to fetch notifications, please try again later!");

            // Check for error response and reject with custom error message
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error);
            }
        }
    }
);